import merge from 'deepmerge'

// import './style/main.scss'

const appDefaults = {
  title: 'Argon Web',
  showTitle: false,
  // colors
  headerColor: 'primary',
  titlebarColor: '#fafafa',
  toolbarHeaderColor: 'white',
  toolbarHeaderDark: false,
  // forms
  useFieldOutline: false,
  // images
  logoSrc: '/img/icons/argon.png',
  authLogoSrc: '/img/icons/signature-block-500w.png',
  headerLogoSrc: '/img/icons/signature-horizontal-white-32h.png',
  backgroundSrc: '',
  // modals
  modalHeaderColor: 'white',
  modalSizeSmall: 400,
  modalSizeDefault: 550,
  modalSizeMedium: 650,
  modalSizeLarge: 850,
  // popups
  popupSizeSmall: 250,
  popupSizeDefault: 350,
  popupSizeMedium: 450,
  popupSizeLarge: 550
}

export default class {
  constructor(opts = {}) {
    this.opts = merge(appDefaults, opts)
  }
}
